import React from 'react';
import { Text, Flex } from '@instructure/ui';
import { getStore, usePlayerStore } from '../../../../stores/StoreContext';
import { randomId } from '../../../../helpers/utilities';
const AnnotationLabels = () => {
  const PlayerStore = getStore('playerStore');
  const displayMarkers = usePlayerStore((state) => state.displayMarkers);
  const markersDisplayProperties = usePlayerStore((state) => state.markersDisplayProperties);

  const renderLabels = () => {
    const labels = [];
    for (const marker of PlayerStore.markers) {
      if (displayMarkers.includes(marker.id)) {
        labels.push(
          <Flex.Item
            key={`marker_label_${randomId()}`}
            as="div"
            padding="none none none x-small"
            width="100%"
            height={`${markersDisplayProperties[marker.id].height}px`}
            textAlign="start"
          >
            <Text size="small">{marker.label}</Text>
          </Flex.Item>
        );
      }
    }

    return labels;
  };

  return renderLabels();
};

export default AnnotationLabels;
